import React, {useEffect} from 'react'
import clsx from 'clsx'
import { makeStyles } from '@material-ui/core/styles'
import {
  Typography,
  ExpansionPanel,
  ExpansionPanelDetails,
  ExpansionPanelSummary,
  Paper,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Fade,
  CircularProgress,
} from '@material-ui/core'
import DonutChart from '../charts/DonutChart'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import { FaSortNumericDown, FaSortNumericUp} from 'react-icons/fa'
import { ImSortAlphaAsc, ImSortAlphaDesc, ImSortNumericAsc, ImSortNumbericDesc} from 'react-icons/im'

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    overflowX: 'auto',
  },
  paper: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    border: '1px solid #283891'
  },
  table: {
    width: '100%',
    minHeight: 300,
    marginRight: 20,
    borderRight: '1px solid #283891',
    overflowX: 'auto',
  },
  title: {
    marginBottom: '15px',
    fontSize: '14px',
    fontWeight: 'bold',
  },
  header: {
    color: 'rgba(255, 255, 255, 1.0)',
    fontWeight: 700,
    '&:hover': {
      cursor: 'pointer',
      color: '#25aae1'
    }
  },
  details: {
    alignItems: 'right'
  },
  column: {
    flexBasis: '50%'
  },
  total: {
    fontWeight: 700,
    color: 'rgba(92, 92, 92)',
    flexBasis: '50%'
  },
  totalDark: {
    fontWeight: 700,
    color: 'rgba(255, 255, 255)',
    flexBasis: '50%'
  },
  labels: {
    display: 'inline-flex',
    alignItems: 'center'
  },
  chart: {
    marginTop: '35px',
    textAlign: 'center',
  //   [theme.breakpoints.down('sm')]: {
  //     display: 'none',
  //
  //   }
  }
}))

function TriggerTypes(props) {
  const classes = useStyles()
  const [loading, setLoading] = React.useState(true)
  const [dataOrdered, setDataOrdered] = React.useState(props.data)
  const [donutSeries, setDonutSeries] = React.useState([])
  const [donutLabels, setDonutLabels] = React.useState([])
  const [orderedBy, setOrderedBy] = React. useState('Label')
  const [order, setOrder] = React.useState('DSC')
  const [colors, setColors] = React.useState(['#00acb3', '#d49a00', '#46bf00', '#b47ddb', '#f28b1f', '#009471', '#7aa3db', '#b79280', '#9800cf', '#e86256', '#818491'])
  const [width, setWidth] = React.useState(window.innerWidth)

  const totalRR = props.data.map(item => item.total.Responses).reduce((a,b) => a + b, 0) / props.data.map(item => item.total.Mailed).reduce((a,b) => a + b, 0)
  const holdoutRR = props.data.map(item => item.total.HO_Resp).reduce((a,b) => a + b, 0) / props.data.map(item => item.total.HO_Count).reduce((a,b) => a + b, 0)

  useEffect(() => {
    // const colors = ['#00d2da', '#f2b000', '#50d500', '#fe8100', '#7d8ddb', '#6ad449', '#7aa3db', '#b79280', '#ff4189', '#9669e7']
    const colors = ['#00acb3', '#d49a00', '#46bf00', '#b47ddb', '#f28b1f', '#009471', '#7aa3db', '#b79280', '#9800cf', '#e86256']

    if(props.data.length > 0) {
      props.data.forEach((item, i) => {
        item.total['Res_Rate'] = item.total.Mailed > 0 ? item.total.Responses / item.total.Mailed : 0
        item.total['HO_Res_Rate'] = item.total.HO_Count > 0 ? item.total.HO_Resp / item.total.HO_Count : 0
        item.total['ADJ_Res_Rate'] = item.total['Res_Rate'] * 100 > 0 && item.total['HO_Res_Rate'] * 100 > 0 ? (item.total.Res_Rate - item.total.HO_Res_Rate) : 0
        item.total['Avg_Ticket'] = item.total.Responses > 0 ? item.total.Sales / item.total.Responses : 0
      })

      props.data.map(item => item.total).sort((a,b) => b.Sales - a.Sales).slice(0, 10).forEach((item, i) => {
        item['color'] = colors[i]
      })

      props.data.filter(item => !item.total.color).forEach(item => {
        item.total['color'] = '#818491'
      })

      setDataOrdered(props.data)

      if(props.data.length > 10) {
        let topTen = props.data.map(item => item.total).sort((a,b) => b.Sales - a.Sales).slice(0, 10)
        let labels = []

        let otherCat = []
        for(let i = 0; i < props.data.length; i++) {
          if(topTen.indexOf(props.data[i].total) === -1) {
            otherCat.push(props.data[i].total)
          }
        }

        let otherCatTotal = otherCat.reduce((a,b) => {
          for(const props in b) {
            if(a.hasOwnProperty(props) && props !== 'Category' && props !== 'Label' && props !== 'Data') a[props] += b[props]
            else if(props === 'Category' || props === 'Label') a[props] = 'Other'
            else a[props] = b[props]
          }
          return a
        }, {})

        setDonutSeries(topTen.concat(otherCatTotal))
        setDonutLabels(topTen.concat(otherCatTotal).map(item => item.Label.toUpperCase()))
        setLoading(false)
      } else {
        setDonutSeries(props.data.map(item => item.total).sort((a,b) => b.Sales - a.Sales))
        setDonutLabels(props.data.map(item => item.total).sort((a,b) =>  b.Sales - a.Sales).map(item => item.Label.toUpperCase()))
        setLoading(false)
      }
    }
  }, [props.data])

  const handleSortColumn = (description) => {
    if(typeof props.data[0].total[description] === 'string') {
      if(orderedBy === description) {
        if(order === 'DSC') {
          setDataOrdered(props.data.sort((a,b) => b.total[description].localeCompare(a.total[description])))
          setOrder('ASC')
        } else {
          setDataOrdered(props.data.sort((a,b) => a.total[description].localeCompare(b.total[description])))
          setOrder('DSC')
        }
      } else {
        setDataOrdered(props.data.sort((a,b) => a.total[description].localeCompare(b.total[description])))
        setOrderedBy(description)
        setOrder('DSC')
      }
    } else if(orderedBy === description && order === 'DSC') {
      setDataOrdered(props.data.sort((a,b) => b.total[description] - a.total[description]))
      setOrder('ASC')
    } else {
      setDataOrdered(props.data.sort((a,b) => a.total[description] - b.total[description]))
      setOrderedBy(description)
      setOrder('DSC')
    }
  }

  console.log(props.data.filter(item => item.total.Sales !== 0 && item.total.Mailed !== 0))

  return(
    <div>
      <Fade in={true} timeout={500}>
        <div>
          <Typography className={classes.title}>TRIGGER TYPES</Typography>
          <Paper className={classes.paper}>
            <Table className={classes.table}>
              <TableHead style={{backgroundColor: '#283891'}}>
                <TableRow>
                  <TableCell className={classes.header} onClick={() => handleSortColumn('Label')}>
                    <div className={classes.labels}>
                      <Typography variant="caption" className={classes.header}>Type</Typography>
                      {orderedBy === 'Label' ? order === 'DSC' ? <ImSortAlphaAsc style={{fontSize: '13px', marginLeft: '5px', marginTop: '-3px'}}/> : <ImSortAlphaDesc style={{fontSize: '13px', marginLeft: '5px', marginTop: '-3px'}}/> : null}
                    </div>
                  </TableCell>
                  <TableCell className={classes.header} onClick={() => handleSortColumn('Cost')} align="right">
                    <div className={classes.labels}>
                      <Typography variant="caption" className={classes.header}>Spend</Typography>
                      {orderedBy === 'Cost' ? order === 'DSC' ? <ImSortNumericAsc style={{fontSize: '13px', marginLeft: '5px', marginTop: '-3px'}}/> : <ImSortNumbericDesc style={{fontSize: '13px', marginLeft: '5px', marginTop: '-3px'}}/> : null}
                    </div>
                  </TableCell>
                  <TableCell className={classes.header} onClick={() => handleSortColumn('Sales')} align="right">
                    <div className={classes.labels}>
                      <Typography variant="caption" className={classes.header}>Sales</Typography>
                      {orderedBy === 'Sales' ? order === 'DSC' ? <ImSortNumericAsc style={{fontSize: '13px', marginLeft: '5px', marginTop: '-3px'}}/> : <ImSortNumbericDesc style={{fontSize: '13px', marginLeft: '5px', marginTop: '-3px'}}/> : null}
                    </div>
                  </TableCell>
                  <TableCell className={classes.header} onClick={() => handleSortColumn('Mailed')} align="right">
                    <div className={classes.labels}>
                      <Typography variant="caption" className={classes.header}>Mailed</Typography>
                      {orderedBy === 'Mailed' ? order === 'DSC' ? <ImSortNumericAsc style={{fontSize: '13px', marginLeft: '5px', marginTop: '-3px'}}/> : <ImSortNumbericDesc style={{fontSize: '13px', marginLeft: '5px', marginTop: '-3px'}}/> : null}
                    </div>
                  </TableCell>
                  <TableCell className={classes.header} onClick={() => handleSortColumn('Responses')} align="right">
                    <div className={classes.labels}>
                      <Typography variant="caption" className={classes.header}>Responses</Typography>
                      {orderedBy === 'Responses' ? order === 'DSC' ? <ImSortNumericAsc style={{fontSize: '13px', marginLeft: '5px', marginTop: '-3px'}}/> : <ImSortNumbericDesc style={{fontSize: '13px', marginLeft: '5px', marginTop: '-3px'}}/> : null}
                    </div>
                  </TableCell>
                  <TableCell className={classes.header} onClick={() => handleSortColumn('Res_Rate')} align="right">
                    <div className={classes.labels}>
                      <Typography variant="caption" className={classes.header}>Response Rate</Typography>
                      {orderedBy === 'Res_Rate' ? order === 'DSC' ? <ImSortNumericAsc style={{fontSize: '13px', marginLeft: '5px', marginTop: '-3px'}}/> : <ImSortNumbericDesc style={{fontSize: '13px', marginLeft: '5px', marginTop: '-3px'}}/> : null}
                    </div>
                  </TableCell>
                  <TableCell className={classes.header} onClick={() => handleSortColumn('HO_Sales')} align="right">
                    <div className={classes.labels}>
                      <Typography variant="caption" className={classes.header}>Holdout Sales</Typography>
                      {orderedBy === 'HO_Sales' ? order === 'DSC' ? <ImSortNumericAsc style={{fontSize: '13px', marginLeft: '5px', marginTop: '-3px'}}/> : <ImSortNumbericDesc style={{fontSize: '13px', marginLeft: '5px', marginTop: '-3px'}}/> : null}
                    </div>
                  </TableCell>
                  <TableCell className={classes.header} onClick={() => handleSortColumn('HO_Count')} align="right">
                    <div className={classes.labels}>
                      <Typography variant="caption" className={classes.header}>Holdout Count</Typography>
                      {orderedBy === 'HO_Count' ? order === 'DSC' ? <ImSortNumericAsc style={{fontSize: '13px', marginLeft: '5px', marginTop: '-3px'}}/> : <ImSortNumbericDesc style={{fontSize: '13px', marginLeft: '5px', marginTop: '-3px'}}/> : null}
                    </div>
                  </TableCell>
                  <TableCell className={classes.header} onClick={() => handleSortColumn('HO_Resp')} align="right">
                    <div className={classes.labels}>
                      <Typography variant="caption" className={classes.header}>Holdout Responses</Typography>
                      {orderedBy === 'HO_Resp' ? order === 'DSC' ? <ImSortNumericAsc style={{fontSize: '13px', marginLeft: '5px', marginTop: '-3px'}}/> : <ImSortNumbericDesc style={{fontSize: '13px', marginLeft: '5px', marginTop: '-3px'}}/> : null}
                    </div>
                  </TableCell>
                    <TableCell className={classes.header} onClick={() => handleSortColumn('HO_Res_Rate')} align="right">
                    <div className={classes.labels}>
                      <Typography variant="caption" className={classes.header}>Holdout Response Rate</Typography>
                      {orderedBy === 'HO_Res_Rate' ? order === 'DSC' ? <ImSortNumericAsc style={{fontSize: '13px', marginLeft: '5px', marginTop: '-3px'}}/> : <ImSortNumbericDesc style={{fontSize: '13px', marginLeft: '5px', marginTop: '-3px'}}/> : null}
                    </div>
                  </TableCell>
                  <TableCell className={classes.header} onClick={() => handleSortColumn('ADJ_Res_Rate')} align="right">
                    <div className={classes.labels}>
                      <Typography variant="caption" className={classes.header}>Inc Response Rate</Typography>
                      {orderedBy === 'ADJ_Res_Rate' ? order === 'DSC' ? <ImSortNumericAsc style={{fontSize: '13px', marginLeft: '5px', marginTop: '-3px'}}/> : <ImSortNumbericDesc style={{fontSize: '13px', marginLeft: '5px', marginTop: '-3px'}}/> : null}
                    </div>
                  </TableCell>
                  <TableCell className={classes.header} onClick={() => handleSortColumn('Avg_Ticket')} align="right">
                    <div className={classes.labels}>
                      <Typography variant="caption" className={classes.header}>Avg Ticket</Typography>
                      {orderedBy === 'Avg_Ticket' ? order === 'DSC' ? <ImSortNumericAsc style={{fontSize: '13px', marginLeft: '5px', marginTop: '-3px'}}/> : <ImSortNumbericDesc style={{fontSize: '13px', marginLeft: '5px', marginTop: '-3px'}}/> : null}
                    </div>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {props.data.length > 0 ?
                  dataOrdered.filter(item => item.total.Sales !== 0 && item.total.Mailed !== 0).map((row, i) => (
                    <TableRow key={i} style={dataOrdered.length % 2 === 0 ?  i % 2 !== 0 ? {backgroundColor: '#efefef'} : {} : i % 2 === 0 ? {backgroundColor: '#efefef'} : {}}>
                      <TableCell><Typography variant="caption" style={{color: `${row.total.color}`}}>{row.label.toUpperCase()}</Typography></TableCell>
                      <TableCell name="spend" align="right"><Typography variant="caption">${Math.round(row.total.Cost).toLocaleString('en')}</Typography></TableCell>
                      <TableCell name="sales" align="right"><Typography variant="caption">${Math.round(row.total.Sales).toLocaleString('en')}</Typography></TableCell>
                      <TableCell name="mail" align="right"><Typography variant="caption">{Math.round(row.total.Mailed).toLocaleString('en')}</Typography></TableCell>
                      <TableCell name="response" align="right"><Typography variant="caption">{Math.round(row.total.Responses).toLocaleString('en')}</Typography></TableCell>
                      <TableCell name="responseRate" align="right"><Typography variant="caption">{(row.total.Res_Rate * 100).toFixed(2) + '%'}</Typography></TableCell>
                      <TableCell name="holdoutSales" align="right"><Typography variant="caption">{'$' + Math.round(row.total.HO_Sales).toLocaleString('en')}</Typography></TableCell>
                      <TableCell name="holdoutCount" align="right"><Typography variant="caption">{Math.round(row.total.HO_Count).toLocaleString('en')}</Typography></TableCell>
                      <TableCell name="holdoutResponse" align="right"><Typography variant="caption">{Math.round(row.total.HO_Resp).toLocaleString('en')}</Typography></TableCell>
                      <TableCell name="holdoutRR" align="right"><Typography variant="caption">{(row.total.HO_Res_Rate * 100).toFixed(2) + '%'}</Typography></TableCell>
                      <TableCell name="incResponseRate" align="right"><Typography variant="caption">{(row.total.ADJ_Res_Rate * 100).toFixed(2) + '%'}</Typography></TableCell>
                      <TableCell name="avgTicket" align="right"><Typography variant="caption">${Math.round(row.total.Avg_Ticket).toLocaleString('en')}</Typography></TableCell>
                    </TableRow>
                  ))
                : <div/>
                }
                <TableRow>
                  <TableCell><Typography variant="caption" className={props.darkMode ? classes.totalDark : classes.total}>{'total'.toUpperCase()}</Typography></TableCell>
                  <TableCell align="right"><Typography variant="caption" className={props.darkMode ? classes.totalDark : classes.total}>{'$' + Math.round(props.data.map(item => item.total.Cost).reduce((a,b) => a + b, 0)).toLocaleString('en')}</Typography></TableCell>
                  <TableCell align="right"><Typography variant="caption" className={props.darkMode ? classes.totalDark : classes.total}>{'$' + Math.round(props.data.map(item => item.total.Sales).reduce((a,b) => a + b, 0)).toLocaleString('en')}</Typography></TableCell>
                  <TableCell align="right"><Typography variant="caption" className={props.darkMode ? classes.totalDark : classes.total}>{Math.round(props.data.map(item => item.total.Mailed).reduce((a,b) => a + b, 0)).toLocaleString('en')}</Typography></TableCell>
                  <TableCell align="right"><Typography variant="caption" className={props.darkMode ? classes.totalDark : classes.total}>{Math.round(props.data.map(item => item.total.Responses).reduce((a,b) => a + b, 0)).toLocaleString('en')}</Typography></TableCell>
                  <TableCell align="right"><Typography variant="caption" className={props.darkMode ? classes.totalDark : classes.total}>{(totalRR * 100).toFixed(2) + '%'}</Typography></TableCell>
                  <TableCell align="right"><Typography variant="caption" className={props.darkMode ? classes.totalDark : classes.total}>{'$' + Math.round(props.data.map(item => item.total.HO_Sales).reduce((a,b) => a + b, 0)).toLocaleString('en')}</Typography></TableCell>
                  <TableCell align="right"><Typography variant="caption" className={props.darkMode ? classes.totalDark : classes.total}>{Math.round(props.data.map(item => item.total.HO_Count).reduce((a,b) => a + b, 0)).toLocaleString('en')}</Typography></TableCell>
                  <TableCell align="right"><Typography variant="caption" className={props.darkMode ? classes.totalDark : classes.total}>{Math.round(props.data.map(item => item.total.HO_Resp).reduce((a,b) => a + b, 0)).toLocaleString('en')}</Typography></TableCell>
                  <TableCell align="right"><Typography variant="caption" className={props.darkMode ? classes.totalDark : classes.total}>{(holdoutRR * 100).toFixed(2) + '%'}</Typography></TableCell>
                  <TableCell align="right"><Typography variant="caption" className={props.darkMode ? classes.totalDark : classes.total}>{((totalRR - holdoutRR) * 100).toFixed(2) + '%'}</Typography></TableCell>
                  <TableCell align="right"><Typography variant="caption" className={props.darkMode ? classes.totalDark : classes.total}>{'$' + Math.round(props.data.map(item => item.total.Sales).reduce((a,b) => a + b, 0) / props.data.map(item => item.total.Responses).reduce((a,b) => a + b, 0)).toLocaleString('en')}</Typography></TableCell>
                </TableRow>
              </TableBody>
            </Table>
            {width >= 768 ?
              loading ? null :
              <div className={classes.chart}>
                <Typography style={{color: '#283891'}} variant="caption">SALES BY TRIGGER TYPES</Typography>
                <DonutChart
                  data={donutSeries.map(item => Math.round(item.Sales))}
                  total={false}
                  radius={'70%'}
                  labels={donutLabels.map(item => item + ' SALES')}
                  labelShow={true}
                  position={'bottom'}
                  height={215}
                  hoverBorderWidth={5}
                  colors={colors}
                />
                {props.data.length >= 9 ?
                  <div>
                    <br/>
                    <br/>
                    <Typography variant="caption" style={{color: '#283891'}}>RESPONSE BY CATEGORY</Typography>
                    <DonutChart
                      data={donutSeries.map(item => Math.round(item.Responses))}
                      total={false}
                      radius={'70%'}
                      labels={donutLabels.map(item => item + ' RESPONSES')}
                      labelShow={true}
                      position={'bottom'}
                      height={215}
                      hoverBorderWidth={5}
                      colors={colors}
                    />
                  </div>
                : null}
              </div>
              :
              null
            }
          </Paper>
        </div>
      </Fade>
    </div>
  )
}

export default TriggerTypes
